export const ADD_CREDIT_LIMIT_MODEL = 'ADD_CREDIT_LIMIT_MODEL';
export const ADD_CREDIT_LIMIT_MODEL_SUCCESS = 'ADD_CREDIT_LIMIT_MODEL_SUCCESS';

export const addCreditLimitModel =(data)=>{
    return{
        type:ADD_CREDIT_LIMIT_MODEL,
        data
    }
}

export const addCreditLimitModelResponse =(data)=>{
    return{
        type:ADD_CREDIT_LIMIT_MODEL_SUCCESS,
        data
    }
}